import React from "react";
import {
  Filter,
  List,
  Edit,
  Create,
  SimpleForm,
  Datagrid,
  TextField,
  TextInput,
  NumberInput,
  DateField,
  NumberField,
  EditButton,
  Responsive,
  SimpleList,
  Show,
  SimpleShowLayout,
  ShowButton,
  ReferenceInput,
  SelectInput,
  GET_ONE,
  DateInput
} from "react-admin";
import { restClient } from "ra-data-feathers";
import feathersClient from "../feathersClient";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { styles } from "../layout/Styles";
import { CartoneroDashboard } from "../components/DashboardCartoneros/Cartonero";
import { ToolbarSave } from "../components/toolbarSave";
import { actionListCustom } from "../components/Wow/actionListCustom";

const maxLength = (
  max,
  message = "Como maximo se permiten 8 caracteres"
) => value => (value && value.length > max ? message : undefined);

const required = (message = "Requerido") => value =>
  value ? undefined : message;
const number = (message = "Tiene que ser numero") => value =>
  value && isNaN(Number(value)) ? message : undefined;

const validateDni = [maxLength(8), required(), number()];

export const CartoneroFilter = props => (
  <Filter {...props}>
    <TextInput label="Nombre" source="searchnombre" alwaysOn />
    <TextInput label="DNI" source="searchdni" />
    <NumberInput label="Bolsón" source="bolson" />
  </Filter>
);

export const CartoneroFilterAdmin = props => (
  <Filter {...props}>
    <TextInput label="Nombre" source="searchnombre" alwaysOn />
    <TextInput label="DNI" source="searchdni" />
    <ReferenceInput reference="etapas" source="etapa" perPage={100} sort={{ field: 'nombre', order: 'ASC' }}>
        <SelectInput  optionText="nombre" optionValue="nombre" />
    </ReferenceInput>
    <NumberInput label="Bolsón" source="bolson" />
  </Filter>
);

const CartoneroNameEdit = ({ record }) => {
  return (
    <Responsive
      small={<span>Editar Recuperador</span>}
      medium={
        <span>Editar Recuperador: {record ? `"${record.nombre}"` : ""}</span>
      }
    />
  );
};

const CartoneroNameShow = ({ record }) => {
  return (
    <Responsive
      small={
        <Typography variant="title">
          {record ? `${record.nombre}` : ""}
        </Typography>
      }
      medium={
        <Typography variant="display1">
          {record ? `Recuperador: ${record.nombre}` : ""}
        </Typography>
      }
    />
  );
};

export class CartoneroShow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cartonero: {
        etapa: "",
        dni: "",
        bolson: "",
        legacyId: "",
        pesajes: {
          acumuladoMensual: 0,
          totalMesAnterior: 0
        }
      },
      open: true
    };
  }

  componentDidMount() {
    const dataProvider = restClient(feathersClient);
    dataProvider(GET_ONE, this.props.basePath, { id: this.props.id }).then(
      response => {
        this.setState({
          cartonero: response.data
        });
      }
    );
  }

  handleClose = () => {
    this.setState({ open: false });
    this.props.history.push("/recuperadores");
  };
  transition = props => {
    return <Slide direction="left" {...props} />;
  };

  render() {
    const { cartonero } = this.state;

    if (cartonero && cartonero !== null) {
      return (
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={this.transition}
          scroll="paper"
        >
          <AppBar style={styles.appBar}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={this.handleClose}
                aria-label="Close"
                tabIndex="-1"
              >
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="title" style={styles.title}>
                {cartonero.nombre}
              </Typography>
            </Toolbar>
          </AppBar>
          <DialogContent style={{ padding: 0 }}>
            <CartoneroDashboard user={cartonero} />
          </DialogContent>
        </Dialog>
      );
    } else {
      return (
        <Show title={<CartoneroNameShow />} {...this.props}>
          <SimpleShowLayout>
            <Typography variant="display2">
              No se encontro al Recuperador
            </Typography>
          </SimpleShowLayout>
        </Show>
      );
    }
  }
}

const Historial = ({ record }) => {
  return (
    <div style={styles.aside}>
      {record && <CartoneroDashboard user={record} />}
    </div>
  );
};

export const CartoneroEdit = props => (
  <Edit title={<CartoneroNameEdit />} aside={<Historial />} {...props}>
    <SimpleForm toolbar={<ToolbarSave {...props} />}>
      <TextInput label="Nombre y Apellido" source="nombre" />
      <TextInput label="D.N.I." source="dni" validate={validateDni} />
      <TextInput label="D.N.I Original" source="dniOriginal" />
      <TextInput label="Id" source="legacyId" />
      <TextInput label="Calle ID" source="calleId" />
      <TextInput label="telefono" source="telefono" />
      <ReferenceInput reference="etapas" source="etapa" perPage={100} sort={{ field: 'nombre', order: 'ASC' }}>
        <SelectInput optionText="nombre" optionValue="nombre" />
      </ReferenceInput>
      <NumberInput label="Bolsón" source="bolson" />
      <TextInput label="Dirección" source="direccion" />
      <DateInput source="fecha_nac" label="Fecha de nacimiento" />
      <TextInput label="Tipo" source="tipo" />
      <TextInput label="Tarea" source="tarea" />
      <TextInput label="Observaciones" source="observaciones" />
      <TextInput label="Contraseña" source="validacion" type="password" />
    </SimpleForm>
  </Edit>
);

export const CartoneroCreate = props => (
  <Create {...props} title="Registrar Recuperador">
    <SimpleForm redirect="list">
      <Grid
        container
        direction="column"
        item
        xs={10}
        sm={6}
        style={{ paddingRight: 80 }}
      >
        <TextInput label="Nombre y Apellido" source="nombre" />
        <TextInput label="D.N.I." source="dni" validate={validateDni} />
        <TextInput label="D.N.I Original" source="dniOriginal" />
        <TextInput label="Id" source="legacyId" />
        <TextInput
          label="Calles"
          source="calleId"
          helperText="Para ingresar más calles utilice las comas"
        />
        <TextInput label="telefono" source="telefono" />
        <ReferenceInput reference="etapas" source="etapa" perPage={100} sort={{ field: 'nombre', order: 'ASC' }}>
          <SelectInput optionText="nombre" optionValue="nombre" />
        </ReferenceInput>
        <NumberInput label="Bolsón" source="bolson" />
        <TextInput label="Dirección" source="direccion" />
        <DateInput source="fecha_nac" label="Fecha de nacimiento" />
        <TextInput label="Tipo" source="tipo" />
        <TextInput label="Tarea" source="tarea" />
        <TextInput label="Observaciones" source="observaciones" />
        <TextInput label="Contraseña" type="password" source="validacion" />
      </Grid>
    </SimpleForm>
  </Create>
);

const ActionList = actionListCustom();

export const EditableCartoneroList = props => (
  <List
    {...props}
    bulkActions={false}
    filters={<CartoneroFilterAdmin />}
    sort={{ field: "nombre", order: "ASC" }}
    actions={<ActionList />}
  >
    <Responsive
      small={
        <SimpleList
          primaryText={record =>
            record.nombre.replace(/\b\w/g, l => l.toUpperCase())
          }
          secondaryText={record =>
            "Acumulado actual: " +
            record.pesajes.acumuladoMensual +
            " Mes Anterior: " +
            record.pesajes.totalMesAnterior
          }
          tertiaryText={record => "DNI: " + record.dni}
        />
      }
      medium={
        <Datagrid>
          <TextField style={{ textTransform: "capitalize" }} source="nombre" />
          <TextField source="dni" />
          <TextField source="dniOriginal" />
          <TextField source="etapa" />
          <NumberField label="Número de bolsón" source="bolson" />
          <TextField label="ID" source="legacyId" />
          <TextField label="Tipo" source="tipo" />
          <TextField label="Tarea" source="tarea" />
          <TextField label="Observaciones" source="observaciones" />
          <TextField label="Última Pesaje" source="pesajes.diario" />
          <DateField label="Fecha y Hora" source="pesajes.fechaHora" />
          <TextField
            label="Acumulado Mensual"
            source="pesajes.acumuladoMensual"
          />
          <TextField
            label="Total Mes Anterior"
            source="pesajes.totalMesAnterior"
          />
          <EditButton />
        </Datagrid>
      }
    />
  </List>
);

export const CartoneroList = props => (
  <List
    {...props}
    bulkActions={false}
    filters={<CartoneroFilter />}
    sort={{ field: "nombre", order: "ASC" }}
  >
    <Responsive
      small={
        <SimpleList
          primaryText={record => record.nombre}
          secondaryText={record =>
            "Bolson: " +
            record.bolson +
            " " +
            "Acumulado: " +
            record.pesajes.acumuladoMensual
          }
          tertiaryText={record => "DNI: " + record.dni}
          linkType="show"
        />
      }
      medium={
        <Datagrid>
          <TextField source="nombre" />
          <TextField source="dni" />
          <TextField source="dniOriginal" />
          <TextField source="etapa" />
          <NumberField label="Número de bolsón" source="bolson" />
          <TextField label="ID" source="legacyId" />
          <TextField label="Tipo" source="tipo" />
          <TextField label="Tarea" source="tarea" />
          <TextField label="Observaciones" source="observaciones" />
          <TextField label="Pesaje Diario" source="pesajes.diario" />
          <TextField
            label="Acumulado Mensual"
            source="pesajes.acumuladoMensual"
          />
          <TextField
            label="Total Mes Anterior"
            source="pesajes.totalMesAnterior"
          />
          <ShowButton label="Detalles" />
        </Datagrid>
      }
    />
  </List>
);



// WEBPACK FOOTER //
// ./src/services/cartoneros.js